import { Card, CardBody, Typography } from "@material-tailwind/react";
import EmptyState from "../../components/common/EmptyState";

function EmptyHireHistory() {


  return (
    <Card  placeholder={undefined}  className="w-1/2">
      <CardBody placeholder={undefined}  className="justify-center items-center">
        <div className="justify-center flex h-20 ">
          <EmptyState />
        </div>
        <Typography placeholder={undefined}  className="text-center">No History yet</Typography>
      </CardBody>
    </Card>
  );
}

export default EmptyHireHistory;
